export default __webpack_public_path__ + "static/media/lulushopping.619007ac.png";